import { render, staticRenderFns } from "./TelephoneContact.vue?vue&type=template&id=85fb62a4&scoped=true"
import script from "./TelephoneContact.vue?vue&type=script&lang=js"
export * from "./TelephoneContact.vue?vue&type=script&lang=js"
import style0 from "./TelephoneContact.vue?vue&type=style&index=0&id=85fb62a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85fb62a4",
  null
  
)

export default component.exports